import { abbreviatedDecimal, percentage } from '../../utils/formatters';

const addDataLabels = (
    datasets,
    {
        showPercentage,
        isDoubled = false,
        showItemValueAsPercentage = false,
        isStacked = false,
        showFixedAbbreviatedDecimal = false,
        customNoDataLabel,
        appendPercentage = false,
    },
) => {
    const perc = (value, ctx) => {
        const total = ctx.chart.config.data.datasets.reduce((acc, dataset) => {
            return acc + dataset.data[ctx.dataIndex];
        }, 0);
        return percentage(total ? value / total : 0);
    };

    const formatter = showPercentage
        ? perc
        : showItemValueAsPercentage
          ? value => percentage(value, { maximumFractionDigits: 1 })
          : value =>
                `${abbreviatedDecimal(
                    value,
                    showFixedAbbreviatedDecimal,
                    customNoDataLabel,
                )}${appendPercentage ? '%' : ''}`;

    return datasets.map(dataset => {
        let datalabels = {
            ...(dataset.datalabels ? { ...dataset.datalabels } : {}),
            anchor: !isDoubled ? 'end' : 'top',
            align: 'top',
            textAlign: 'center',
            offset: 4,
            formatter,
        };

        if (isStacked) {
            datalabels = {
                font: {
                    family: 'pnbold',
                },
                align: 'end',
                anchor: 'end',
                textAlign: 'center',
                formatter: (value, ctx) => {
                    return abbreviatedDecimal(
                        ctx.chart.$totalizer.totals[ctx.dataIndex],
                    );
                },
                display: function (ctx) {
                    return ctx.datasetIndex === ctx.chart.$totalizer.utmost;
                },
            };
        }

        return {
            ...dataset,
            datalabels,
        };
    });
};

export default addDataLabels;
